<template>
    <div id="app">
        <FloatingAlert />
        <router-view />
    </div>
</template>

<script>
import FloatingAlert from '@/components/FloatingAlert.vue';

export default {
    components: {
        FloatingAlert
    }
};
</script>
